module.exports = __webpack_public_path__ + "img/cover-final.d91a8893.png";